module.exports = __webpack_public_path__ + "static/img/summer_liziPic.c434f418.png";